import { render, staticRenderFns } from "./typelicense.vue?vue&type=template&id=a50c4e8c&scoped=true&"
import script from "./typelicense.vue?vue&type=script&lang=js&"
export * from "./typelicense.vue?vue&type=script&lang=js&"
import style0 from "./typelicense.vue?vue&type=style&index=0&id=a50c4e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50c4e8c",
  null
  
)

export default component.exports